export const AuthenticationDocsLink =
  'https://docs.sequencehq.com/reference/authentication'
